// extracted by mini-css-extract-plugin
export default {"choice":"resolution-panel_choice__5tqu+"};